module.exports = __webpack_public_path__ + "img/plant_icon.3b77b3a0.png";